module.exports = __webpack_public_path__ + "static/media/bp1.356e817a.jpg";